module.exports = __webpack_public_path__ + "img/certification.206cc5b4.png";